import { GalleryContext } from "./chunk-JMBPVZMW.js";
import { scrollTo } from "./chunk-KROBAS26.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Gallery/Gallery.Root.tsx
import React, { useMemo, Children, cloneElement, useContext, useEffect } from "react";
import clsx from "clsx";
import { debounce } from "es-toolkit";
var GalleryRoot = _a => {
  var _b = _a,
    {
      children: childrenProp,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  const {
    id,
    prevButton,
    nextButton,
    zoomButton,
    setTotalItems,
    totalItems,
    activeItem,
    setActiveItem
  } = useContext(GalleryContext);
  const rootRef = React.createRef();
  const children = useMemo(() => Children.map(childrenProp, (child, index) => cloneElement(child, {
    itemNumber: index + 1
  })), [childrenProp]);
  const handleScrollCapture = debounce(() => {
    if (!rootRef.current) return;
    setActiveItem(Math.round(rootRef.current.scrollLeft / rootRef.current.clientWidth) + 1);
  }, 200);
  useEffect(() => {
    setTotalItems(Children.count(children));
  }, [children, setTotalItems]);
  useEffect(() => {
    if (rootRef.current) {
      scrollTo(rootRef.current, {
        left: rootRef.current.clientWidth * (activeItem - 1),
        behavior: "smooth"
      });
    }
  }, [activeItem, rootRef, totalItems]);
  return /* @__PURE__ */React.createElement("div", {
    className: "pd-relative",
    onScrollCapture: handleScrollCapture
  }, /* @__PURE__ */React.createElement("ol", __spreadValues({
    ref: rootRef,
    id: "".concat(id, "-items"),
    role: "region",
    "aria-roledescription": "carousel",
    className: clsx("pd-gallery", className)
  }, rest), children), prevButton, nextButton, zoomButton);
};
var Gallery_Root_default = GalleryRoot;
export { Gallery_Root_default };